import { render, staticRenderFns } from "./DetailGift.vue?vue&type=template&id=41d576e2&"
import script from "./DetailGift.vue?vue&type=script&lang=js&"
export * from "./DetailGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports